import { FieldSelected } from "@/hooks/eventing/types/redventures.usertracking.v3.FieldSelected";
import {
  getCorrelationID,
  getPageType,
  getWebContext,
} from "@/utils/tagular/helpers";

type RecentlyAddedFieldType = "search-filters" | "search-filters-modal";

/** Builds a FieldSelected analytics event for the "Recently Added" filter toggle.
 * Must be called in a browser context (requires `document` and `window`).
 * fieldName uses filterOptionLabel to align with other filters (Dropdown, FilterItem).
 */
export function buildRecentlyAddedFieldEvent(
  fieldType: RecentlyAddedFieldType,
  filterLabel: string,
  filterOptionLabel: string,
  isSelected: boolean,
): FieldSelected {
  const base = getWebContext();
  return {
    correlationId: getCorrelationID(),
    userInputField: {
      fieldName: filterOptionLabel,
      fieldLabel: filterLabel,
      fieldType,
      fieldValue: isSelected ? "Deselected" : "Selected",
    },
    webContext: {
      ...base,
      userAgent: base?.userAgent ?? undefined,
      page: {
        title: document.title,
        url: window.location.href,
        pageType: getPageType(),
      },
    },
    "@type": "redventures.usertracking.v3.FieldSelected",
  };
}
